export function ImagineMark() {
  return (
    <div
      aria-hidden="true"
      className="flex size-14 items-center justify-center rounded-2xl bg-foreground text-background shadow-sm"
    >
      <span className="text-xl font-semibold tracking-tight">I</span>
    </div>
  )
}
